import axios from 'axios'

export const creditApi = {

    getMyCreditAccount() {
        return axios
            .get('/api/v1/credit/getmycreditaccount')
            .then((response) => {
                return response.data
            })
    },

    GetMyStoreCreditBalance() {
        return axios
            .get('/api/v1/credit/GetMyStoreCreditBalance')
            .then((response) => {
                return response.data
            })
    },

}
